module.exports = __webpack_public_path__ + "static/favicon-12e6a79340729519f43425d9ef060e91.ico";